import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconChoose = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon-choose"
    ref={ref}
    {...omit(props, ["className"])}
  >
    <circle cx="12" cy="12" r="12" fill="#25F4EE" />
    <path
      d="M16.7955 5.86816L18.4035 6.99616L11.4315 17.0522H9.82355L5.93555 11.6042L7.54355 10.1042L10.6275 12.9842L16.7955 5.86816Z"
      fill="#17215C"
    />
  </svg>
));

IconChoose.displayName = "IconChoose";

export default IconChoose;
